import styled from "styled-components";
import theme from "../../styles/theme";
import { useState } from "react";

const MainWrap = styled.div`
    width: 100%;
    max-width: 100%;
    height: 2rem;
    display: grid;
    grid-template-columns: 1rem repeat(${(props)=> props.length}, minmax(6rem, 10rem)) calc(100% - ${(props)=> props.length*10}rem);
    align-items: end;
    justify-content: center;
    // border: 1px solid red;
    span {
        cursor: pointer;
        padding-left: 12px;
        font-size: 1rem;
        line-height: 2rem;
        display: inline-box;
        box-sizing: border-box;
        border-bottom: 1px solid ${theme.color.black[20]};
    }
    div {
        border-bottom: 1px solid ${theme.color.black[20]};
    }
    .selected {
        font-weight: 600;
        border-bottom: 2px solid ${theme.color.black[40]};
        // transition: border-bottom 50ms ease-in-out;
    }
    
`
const CommonTab = ({tabList, onClick}) => {

    const [tabIndex, setTabIndex] = useState(0);

    const handleClick = (index) => {
        setTabIndex(index);
        onClick && onClick(index);
    }

    return (
        <MainWrap length={(tabList && tabList.length > 0) ? tabList.length : 0}>
            <div/>
            {tabList && tabList.map((item,index)=>{
                return <span key={index} className={tabIndex === index ? "selected" : "nonSelected"} onClick={()=>handleClick(index)}>{item}</span>
            })}
            <div/>
        </MainWrap>
    )

}

export default CommonTab;